// extracted by mini-css-extract-plugin
module.exports = {"page":"pageTemplate-module--page--2c4UA","pageTitle":"pageTemplate-module--page-title--348AU","pageBody":"pageTemplate-module--page-body--3d6xO"};